var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFeedbackBtn = function SvgFeedbackBtn(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0066F6",
    d: "M30.625 10H9.375C4.197 10 0 14.477 0 20s4.197 10 9.375 10h21.25C35.803 30 40 25.523 40 20s-4.197-10-9.375-10",
    className: "feedback-btn_svg__feedback-cloud"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4M20 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4M27 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    className: "feedback-btn_svg__feedback-dot"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0066F6",
    d: "m19.657 35.314 5.657-5.657L19.657 24 14 29.657z",
    className: "feedback-btn_svg__feedback-cloud"
  })));
};
export default SvgFeedbackBtn;